import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Youtube, Twitter, Heart } from 'lucide-react';
import { footerNavigation } from '../../data/navigation';

export default function Footer() {
  const { t } = useTranslation();

  const socialIcons = [
    { icon: <Facebook className="w-5 h-5" />, href: "https://facebook.com/estad", label: "Facebook" },
    { icon: <Instagram className="w-5 h-5" />, href: "https://instagram.com/estad", label: "Instagram" },
    { icon: <Linkedin className="w-5 h-5" />, href: "https://linkedin.com/school/estad", label: "LinkedIn" },
    { icon: <Youtube className="w-5 h-5" />, href: "https://youtube.com/estad", label: "YouTube" },
    { icon: <Twitter className="w-5 h-5" />, href: "https://twitter.com/estad", label: "Twitter" }
  ];

  return (
    <footer className="bg-navy text-white pt-24 pb-12 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        
        {/* Tier 1: Primary Links - Horizontal Bar with gold separators */}
        <div className="flex flex-wrap justify-center gap-x-8 md:gap-x-12 gap-y-6 text-sm font-black mb-20 uppercase tracking-widest text-center">
          {footerNavigation.quickLinks.map((link, idx) => (
            <div key={`footer-ql-${idx}`} className="flex items-center gap-8 md:gap-12">
              <Link to={link.href} className="hover:text-gold transition-colors duration-300">
                {t(`footer_link_${link.label.toLowerCase().replace(' ', '_')}`, link.label)}
              </Link>
              {idx < footerNavigation.quickLinks.length - 1 && (
                <span className="opacity-20 hidden md:inline text-gold">|</span>
              )}
            </div>
          ))}
        </div>

        {/* Tier 2: Social Icons - Professional circular style */}
        <div className="flex justify-center gap-6 md:gap-10 mb-20">
          {socialIcons.map((social, idx) => (
            <a 
              key={idx}
              href={social.href} 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label={social.label}
              className="w-12 h-12 rounded-full border border-white/20 flex items-center justify-center hover:bg-gold hover:text-navy hover:border-gold transition-all duration-500 shadow-lg hover:-translate-y-1"
            >
              {social.icon}
            </a>
          ))}
        </div>

        {/* Tier 3: Copyright & Secondary Links */}
        <div className="text-center space-y-8">
          <p className="text-xs opacity-50 tracking-wide font-light max-w-2xl mx-auto">
            &copy; 2026 ESTAD - École Supérieure des Techniques Avancées pour le Développement. {t('footer_rights_reserved', 'Tous droits réservés.')}
          </p>
          
          <div className="flex flex-wrap justify-center gap-x-8 md:gap-x-12 gap-y-4 text-[11px] font-black uppercase tracking-[0.25em] opacity-60">
            {footerNavigation.legal.map((link, idx) => (
              <Link key={`footer-legal-${idx}`} to={link.href} className="hover:text-gold transition-colors underline-offset-4 hover:underline">
                {t(`footer_legal_${link.label.toLowerCase()}`, link.label)}
              </Link>
            ))}
            <Link to="/contact" className="hover:text-gold transition-colors underline-offset-4 hover:underline">CONTACT</Link>
          </div>

          {/* Tier 4: Bottom Utility / Compliance */}
          <div className="pt-16 border-t border-white/5 text-[10px] opacity-30 uppercase tracking-[0.3em] flex flex-col items-center gap-6">
            <div className="flex flex-wrap justify-center gap-8 items-center">
              <Link to="/donate" className="flex items-center gap-2 hover:text-gold transition-colors">
                <Heart className="w-3 h-3 fill-gold text-gold" /> {t('nav_donate')}
              </Link>
              <span>{t('footer_recaptcha_notice', 'Ce site est protégé par reCAPTCHA')}</span>
            </div>
            <div className="flex gap-4">
              <Link to="/contact" className="underline hover:text-white transition-colors">{t('footer_privacy', 'Confidentialité')}</Link>
              <Link to="/contact" className="underline hover:text-white transition-colors">{t('footer_terms', 'Conditions')}</Link>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
}
